import script from "./OurValues.vue?vue&type=script&setup=true&lang=js"
export * from "./OurValues.vue?vue&type=script&setup=true&lang=js"

import "./OurValues.vue?vue&type=style&index=0&id=1443a24a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1443a24a"]])

export default __exports__